module.exports = __webpack_public_path__ + "img/img3.f3dbd478.jpg";